define([
	'internal_util/Util',
	'internal_util/UiUtil',
	'amdi18n-loader?!identity/nls/IdentityButtonView_strings',
	'amdi18n-loader?!state/nls/PrivacyPolicyState_strings',
	'lib/jquery'
], function (
	Util,
	UiUtil,
	Strings,
	PrivacyStrings,
	jQuery
) {
	'use strict';

	/**
	 * IdentityButtonView class
	 */
	return function (renew, extend, transfer, doExport, encrypt, decrypt, enable, disable, doDelete, revokeAll) {
		var _enableCallback = enable,
			_disableCallback = disable,
			_encryptCallback = encrypt,
			_decryptCallback = decrypt,
			_view;

		_view = (function () {
			var $view = jQuery(
					'<div id="skIdS_identity-button-container">' +
						'<button id="skIdS_show-buttons-button" type="button" class="btn btn-default"></button>' +
						'<div>' +
							'<button id="skIdS_renew-button" type="button" class="btn btn-default skIdS_identity-button"></button>' +
//							'<button id="skIdS_extend-button" type="button" class="btn btn-default skIdS_identity-button"></button>' +
							'<button id="skIdS_transfer-button" type="button" class="btn btn-default skIdS_identity-button"></button>' +
//							'<button id="skIdS_export-button" type="button" class="btn btn-default skIdS_identity-button"></button>' +
//							'<button id="skIdS_su-button" type="button" class="btn btn-default skIdS_identity-button"></button>' +
//							'<button id="skIdS_ad-button" type="button" class="btn btn-default skIdS_identity-button"></button>' +
							'<button id="skIdS_delete-button" type="button" class="btn btn-default skIdS_identity-button"></button>' +
							'<button id="skIdS_revoke-all-button" type="button" class="btn btn-default skIdS_identity-button"></button>' +
						'</div>' +
					'</div>');

			$view.find('.skIdS_identity-button').on('click', function () {
				$view.find('.skIdS_identity-button').removeClass('skIdS_identity-button-active');
				jQuery(this).addClass('skIdS_identity-button-active');
			});

			$view.find('#skIdS_show-buttons-button')
				.text(Strings.show_buttons)
				.on('click', function () {
					toggleButtons();
				});

			$view.find('#skIdS_renew-button')
				.text(Strings.renew)
				.on('click', function () {
					toggleButtons();
					Util.callCallbacks(renew);
				});

//			$view.find('#skIdS_extend-button')
//				.text(Strings.extend)
//				.on('click', function () {
//					toggleButtons();
//					Util.callCallbacks(extend);
//				});

			$view.find('#skIdS_transfer-button')
				.text(Strings.transfer)
				.on('click', function () {
					toggleButtons();
					Util.callCallbacks(transfer);
				});

//			$view.find('#skIdS_export-button')
//				.text(Strings['export'])
//				.on('click', function () {
//					toggleButtons();
//					Util.callCallbacks(doExport);
//				});

			$view.find('#skIdS_su-button')
				.text(Strings.protect_with_pin)
				.on('click', function () {
					toggleButtons();
					Util.callCallbacks(decrypt);
				});

//			$view.find('#skIdS_ad-button')
//				.text(Strings.deactivate)
//				.on('click', function () {
//					toggleButtons();
//					Util.callCallbacks(disable);
//				});

			$view.find('#skIdS_delete-button')
				.text(Strings['delete'])
				.on('click', function () {
					toggleButtons();
					Util.callCallbacks(doDelete);
				});

			$view.find('#skIdS_revoke-all-button')
				.text(PrivacyStrings.revoke_cloud_identities)
				.on('click', function () {
					toggleButtons();
					Util.callCallbacks(revokeAll);
				});

			return $view;
		})();


		// private methods

		function toggleButtons() {
			if (_view.find('#skIdS_show-buttons-button').is(':visible')) {
				UiUtil.scrollTo(_view);

				_view.children().last().toggleClass('skIdS_shown');
			}
		}


		// public methods

		this.get = function () {
			return _view;
		};

		this.removeActiveStates = function () {
			_view.find('button').removeClass('skIdS_identity-button-active');
		};

		this.hideButtonMenu =  function () {
			if (_view.find('#skIdS_show-buttons-button').is(':visible')
					&& _view.children().last().hasClass('skIdS_shown')) {
				_view.children().last().removeClass('skIdS_shown');
			}
		};

		this.update = function (identity, canCreate, identityState) {
			var nullOrExpiredOrRevoked = (identity === null)
					|| ! identity.isValid()
					|| identityState === 'expired'
					|| identityState === 'revoked';
			
			_view.find('#skIdS_renew-button').prop('disabled', !canCreate);
			//_view.find('#skIdS_extend-button').prop('disabled', !canCreate);

			if (! nullOrExpiredOrRevoked) {
				_view.find('#skIdS_transfer-button').prop('disabled', false);
				_view.find('#skIdS_export-button').prop('disabled', false);
				_view.find('#skIdS_su-button').prop('disabled', false);
//				_view.find('#skIdS_revoke-all-button').prop('disabled', false);
//				_view.find('#skIdS_ad-button').prop('disabled', false);

				if (identity.isEncrypted()) {
					_view.find('#skIdS_su-button')
						.text(Strings.remove_pin)
						.unbind('click')
						.on('click', function () {
							_view.find('.skIdS_identity-button').removeClass('skIdS_identity-button-active');
							jQuery(this).addClass('skIdS_identity-button-active');

							toggleButtons();

							Util.callCallbacks(_decryptCallback);
						});
				} else {
					_view.find('#skIdS_su-button')
						.text(Strings.protect_with_pin)
						.unbind('click')
						.on('click', function () {
							_view.find('.skIdS_identity-button').removeClass('skIdS_identity-button-active');
							jQuery(this).addClass('skIdS_identity-button-active');

							toggleButtons();

							Util.callCallbacks(_encryptCallback);
						});
				}

//				if (identity.isEnabled()) {
//					_view.find('#skIdS_ad-button')
//						.text(Strings.deactivate)
//						.unbind('click')
//						.on('click', function () {
//							_view.find('.skIdS_identity-button').removeClass('skIdS_identity-button-active');
//							jQuery(this).addClass('skIdS_identity-button-active');
//
//							toggleButtons();
//
//							Util.callCallbacks(_disableCallback);
//						});
//				} else {
//					_view.find('#skIdS_ad-button')
//						.text(Strings.activate)
//						.unbind('click')
//						.on('click', function () {
//							_view.find('.skIdS_identity-button').removeClass('skIdS_identity-button-active');
//							jQuery(this).addClass('skIdS_identity-button-active');
//
//							toggleButtons();
//
//							Util.callCallbacks(_enableCallback);
//						});
//				}
			} else {
				_view.find('#skIdS_transfer-button').prop('disabled', true);
				_view.find('#skIdS_export-button').prop('disabled', true);
				_view.find('#skIdS_su-button').prop('disabled', true);
//				_view.find('#skIdS_revoke-all-button').prop('disabled', true);
//				_view.find('#skIdS_ad-button').prop('disabled', true);
			}
		};
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/identity/IdentityButtonView.js
// module id = 332
// module chunks = 1